import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onBeforeUnmount } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TextEditor',
  setup(__props) {

const editor = ref<HTMLElement | null>(null);
let quill: any = null;

onMounted(async () => {
  if (typeof window !== "undefined") {
    const Quill = (await import("quill")).default;
    import("quill/dist/quill.snow.css");

    if (editor.value) {
      quill = new Quill(editor.value, {
        theme: "snow",
        placeholder: "Insert text here ...",
        modules: {
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
          ],
        },
      });
      editor.value.style.height = "200px";
    }
  }
});

onBeforeUnmount(() => {
  if (quill) {
    quill = null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "editor",
    ref: editor
  }, null, 512))
}
}

})